<template>
  <ModalDefault modal_id="addUser"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_686')"
                :footer="new_user.name && new_user.email && new_user.password"
                :method="addUser"
                icon="bx bx-group mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class=" d-flex">
        <div class="file-upload-center cursor-default w-100"  style="align-items: center; align-self: center;">
          <div class="d-block pt-2 px-2">
            <div class="row d-flex align-content-around p-0">
              <div class="col-md-6">
                <label class="mb-0">{{ getTranslations('expression_42') }} </label>
                <div class="input-group mb-4">
                  <input ref="adduser_name" v-model="new_user.name" type="text" class="input_forms form-control">
                </div>
              </div>
              <div class="col-md-6">
                <label class="mb-0">{{ getTranslations('expression_161') }} </label>
                <div class="input-group mb-4">
                  <input v-model="new_user.email" type="email" class="input_forms form-control">
                </div>
              </div>
            </div>
            <div class="row d-flex align-content-around p-0">
              <div class="col-md-6">
                <label class="mb-0">{{ getTranslations('expression_222') }} </label>
                <div class="input-group mb-3">
                  <input v-model="new_user.password" type="password" class="input_forms form-control">
                </div>
              </div>
              <div class="col-md-6">
                <label class="mb-0">{{ getTranslations('expression_687') }} </label>
                <div class="input-group mb-3">
                  <select v-model="new_user.role_key" class="input_forms custom-select">
                    <option selected disabled>{{ getTranslations('expression_285') }}</option>
                    <option :value="0">{{ getTranslations('expression_81') }}</option>
                    <option :value="1">{{ getTranslations('expression_688') }}</option>
                    <option :value="2">{{ getTranslations('expression_689') }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2">
      <span @click.prevent="addUser" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_690') }}</span>
        </span>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalAddUser",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['channels']),
    ...mapGetters([])
  },
  data(){
    return {
      new_user: {
        name: "",
        email: "",
        password: "",
        channel_id: null,
        role_key: 0
      },
    }
  },
  mounted() {
    $('#addUser').on('hidden.bs.modal', () => {
      this.new_user = {
        name: "",
        email: "",
        password: "",
        channel_id: null,
        role_key: 0
      }
    })
  },
  methods: {
    addUser() {
      this.$store.dispatch('addUser', this.new_user)
    },
    showUser(){
      this.$swal.fire({
        position: 'center',
        icon: 'success',
        title: this.getTranslations('expression_893'),
        showConfirmButton: false,
        timer: 1500
      })
      this.$router.push({name: 'User'})
    },
  }
}
</script>

<style scoped>

</style>
